// 筛选item坐标是否在这些box里面
export const isInBoxList = (item, boxList) => {
  const res = {
    in: false,
    box: []
  }
  for (let i = 0; i < boxList.length; i += 1) {
    const boxItem = boxList[i]
    if (
      boxItem[0][0] > item[0] && boxItem[1][0] < item[0] &&
      boxItem[0][1] > item[1] && boxItem[1][1] < item[1] &&
      boxItem[0][2] > item[2] && boxItem[1][2] < item[2]
    ) {
      res.in = true
      res.box = boxItem
      break
    }
  }
  return res
}

// 筛选box里面的marker
export const filterPosInBox = (markerList, boxItem) => {
  const res = []
  markerList.forEach((item) => {
    const inBool =
          boxItem[0][0] > item.pos[0] && boxItem[1][0] < item.pos[0] &&
          boxItem[0][1] > item.pos[1] && boxItem[1][1] < item.pos[1] &&
          boxItem[0][2] > item.pos[2] && boxItem[1][2] < item.pos[2]
    if (inBool) {
      res.push({
        markerId: item.id,
        options: {
          visible: true,
        }
      })
    } else {
      res.push({
        markerId: item.id,
        options: {
          visible: false,
        }
      })
    }
  })
  return res
}

// 把box里面的隐藏，box外面的显示
export const filterPosOutBoxs = (markerList, boxList) => {
  const res = []
  markerList.forEach((item) => {
    res.push({
      markerId: item.id,
      options: {
        pos: item.pos,
        visible: true,
      }
    })
  })
  boxList.forEach((boxItem) => {
    res.forEach((markerItem) => {
      const inBool =
              boxItem[0][0] > markerItem.options.pos[0] && boxItem[1][0] < markerItem.options.pos[0] &&
              boxItem[0][1] > markerItem.options.pos[1] && boxItem[1][1] < markerItem.options.pos[1] &&
              boxItem[0][2] > markerItem.options.pos[2] && boxItem[1][2] < markerItem.options.pos[2]
      if (inBool) { // marker在box里面， 隐藏
        markerItem.options.visible = false
      }
    })
  })
  return res
}
